import React from 'react';
import './Terms.scss';

function PrivacyPolicy() {
return (
    <div className="terms-container">
    <h2>개인정보 처리방침</h2>
    
    <section>
        <p className="intro">
        매쓰테일러(이하 "회사")는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 관련 법령상의 
        개인정보보호 규정을 준수하며, 회원의 개인정보 보호에 최선을 다하고 있습니다.
        </p>
    </section>

    <section>
        <h3>제1조 (개인정보의 수집 및 이용 목적)</h3>
        <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
        <ol>
        <li>회원 가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지 등</li>
        <li>서비스 제공: AI 기반 수학 문제 생성·변형 서비스, PDF 변환 서비스, 이미지 처리 서비스 등의 제공</li>
        <li>결제 및 정산: 유료 서비스 이용에 따른 요금 결제, 환불 처리</li>
        <li>고객 지원: 문의사항 처리, 공지사항 전달, 민원 처리 등</li>
        <li>마케팅 및 광고: 신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 (동의한 경우에 한함)</li>
        </ol>
    </section>

    <section>
        <h3>제2조 (수집하는 개인정보의 항목)</h3>
        <p>회사는 회원가입, 서비스 제공 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
        
        <h4>1. 필수 수집 항목</h4>
        <ul>
        <li>아이디(ID)</li>
        <li>비밀번호 (암호화하여 저장)</li>
        <li>이름</li>
        <li>이메일 주소</li>
        <li>휴대폰 번호</li>
        </ul>

        <h4>2. 선택 수집 항목</h4>
        <ul>
        <li>쿠폰코드</li>
        </ul>

        <h4>3. 서비스 이용 과정에서 자동으로 수집되는 정보</h4>
        <ul>
        <li>IP 주소, 쿠키, 서비스 이용 기록, 접속 로그, 결제 기록</li>
        <li>업로드한 파일의 메타데이터 (파일명, 크기, 페이지 수 등)</li>
        </ul>
    </section>

    <section>
        <h3>제3조 (개인정보의 보유 및 이용기간)</h3>
        <ol>
        <li>회원의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.</li>
        <li>회원 탈퇴 시 개인정보는 즉시 파기됩니다. 단, 다음의 정보는 아래의 이유로 명시한 기간 동안 보존됩니다.
            <ul>
            <li>전자상거래 등에서의 소비자보호에 관한 법률에 따른 보관
                <ul>
                <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
                <li>대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
                <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
                </ul>
            </li>
            <li>통신비밀보호법에 따른 보관
                <ul>
                <li>접속 로그 기록: 3개월</li>
                </ul>
            </li>
            </ul>
        </li>
        </ol>
    </section>

    <section>
        <h3>제4조 (개인정보의 파기절차 및 방법)</h3>
        <ol>
        <li>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.</li>
        <li>파기절차
            <ul>
            <li>회원이 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.</li>
            </ul>
        </li>
        <li>파기방법
            <ul>
            <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
            <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
            </ul>
        </li>
        </ol>
    </section>

    <section>
        <h3>제5조 (개인정보 제공)</h3>
        <ol>
        <li>회사는 원칙적으로 회원의 개인정보를 외부에 제공하지 않습니다.</li>
        <li>다만, 아래의 경우에는 예외로 합니다.
            <ul>
            <li>회원이 사전에 동의한 경우</li>
            <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
            </ul>
        </li>
        </ol>
    </section>

    <section>
        <h3>제6조 (개인정보 처리의 위탁)</h3>
        <p>회사는 서비스 향상을 위하여 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.</p>
        
        <h4>현재 위탁 현황</h4>
        <ul>
        <li>결제 처리: 토스페이먼츠 (결제 및 정산 업무)</li>
        <li>문자 발송: SMS 발송 대행업체 (인증번호 및 알림 발송)</li>
        <li>클라우드 스토리지: AWS S3 (파일 저장 및 관리)</li>
        </ul>
    </section>

    <section>
        <h3>제7조 (정보주체의 권리·의무 및 행사방법)</h3>
        <ol>
        <li>회원은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 가입 해지를 요청할 수도 있습니다.</li>
        <li>회원의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' 등)을, 가입해지(동의철회)를 위해서는 '회원탈퇴'를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.</li>
        <li>혹은 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</li>
        <li>회원이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.</li>
        </ol>
    </section>

    <section>
        <h3>제8조 (개인정보 자동 수집 장치의 설치·운영 및 거부)</h3>
        <ol>
        <li>회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</li>
        <li>쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</li>
        <li>쿠키의 사용 목적: 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공</li>
        <li>쿠키 설정 거부 방법: 웹브라우저 옵션 설정을 통해 쿠키 허용, 쿠키 차단 등의 설정을 할 수 있습니다.
            <ul>
            <li>Internet Explorer: 도구 메뉴 선택 &gt; 인터넷 옵션 선택 &gt; 개인정보 탭 클릭 &gt; 개인정보보호 수준 설정</li>
            <li>Chrome: 설정 메뉴 선택 &gt; 고급 설정 표시 선택 &gt; 개인정보 섹션에서 콘텐츠 설정 선택 &gt; 쿠키 섹션에서 설정</li>
            </ul>
        </li>
        </ol>
    </section>

    <section>
        <h3>제9조 (개인정보의 안전성 확보조치)</h3>
        <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
        <ol>
        <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
        <li>기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
        <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
        <li>비밀번호 암호화: 회원의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있습니다.</li>
        </ol>
    </section>

    <section>
        <h3>제10조 (개인정보보호책임자)</h3>
        <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.</p>
        
        <div className="contact-info">
        <h4>개인정보보호책임자</h4>
        <ul>
            <li>담당부서: 개발팀</li>
            <li>이메일: mathtailer@naver.com</li>
            <li>전화번호: 010-8890-6672</li>
        </ul>
        </div>

        <p>정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보보호책임자에게 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>
    </section>

    <section>
        <h3>제11조 (권익침해 구제방법)</h3>
        <p>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.</p>
        
        <ul>
        <li>개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)</li>
        <li>개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)</li>
        <li>대검찰청: (국번없이) 1301 (www.spo.go.kr)</li>
        <li>경찰청: (국번없이) 182 (ecrm.cyber.go.kr)</li>
        </ul>
    </section>

    <section>
        <h3>제12조 (개인정보 처리방침의 변경)</h3>
        <ol>
        <li>이 개인정보 처리방침은 2026년 4월 15일부터 적용됩니다.</li>
        <li>이전의 개인정보 처리방침은 아래에서 확인할 수 있습니다.</li>
        <li>본 개인정보 처리방침의 내용 추가, 삭제 및 수정이 있을 경우에는 개정 최소 7일 전부터 서비스의 '공지사항'을 통해 고지할 것입니다.</li>
        </ol>
    </section>

    <section className="terms-footer">
        <p>공고일자: 2026년 4월 15일</p>
        <p>시행일자: 2026년 4월 15일</p>
    </section>
    </div>
);
}

export default PrivacyPolicy;
